export const environment = {
  production: true,
  APIBASEURL: 'https://webex-backend.sabrhub.com/v1',
  IAM_BACKEND_URL: 'https://usermanagement.sabrhub.com/v1',
  STRIPE_INVITE_PURCHASE_URL: 'https://checkout.sabrhub.com/b/00g29paaA9nR7AIaER'
};
